interface Option {
  value: string | number
  label: string | number
}
type Options = Option[]

export const platforms: Options = [
  {
    label: '淘宝',
    value: 'tb',
  },
  {
    label: '京东',
    value: 'jd',
  },
  {
    label: '快手',
    value: 'ks',
  },
  {
    label: '拼多多',
    value: 'pdd',
  },
  {
    label: '抖音',
    value: 'dy',
  },
  {
    label: '开放平台',
    value: 'open',
  },
  {
    label: '企微',
    value: 'wx',
  },
  {
    label: '京东质检',
    value: 'jdqc',
  },
  {
    label: '得物',
    value: 'dw',
  },
  {
    label: '小红书',
    value: 'xhs',
  },
  {
    label: '唯品会',
    value: 'wph',
  },
  {
    label: '微信小店',
    value: 'wxxd',
  },
]

export const IconMaps = {
  0: 'icongongdan-Text',
  9: 'icona-gongdan-multi-linetext',
  2: 'icona-gongdan-valueofnumber',
  3: 'icongongdan-pull-down',
  4: 'icongongdan-checkbox',
  5: 'iconbase-calender',
  6: 'icona-gongdan-dateandtime',
  10: 'icongongdan-Radio',
  13: 'icona-gongdan-uploadpictures',
  14: 'icongongdan-pull-down',
  15: 'iconbase-tips-one',
  16: 'icona-gongdan-multistagedrop-down',
  101: 'icongongdan-state',
  102: 'icongongdan-priority',
  103: 'icongongdan-handler',
  106: 'icona-gongdan-Followupontime',
  200: 'icongongdan-accessory',
  201: 'icona-gongdan-ordernumber',
  202: 'icongongdan-invoice',
  203: 'icongongdan-nickname',
  204: 'iconnonbase-market',
  206: 'icongongdan-plaform',
  207: 'icona-gongdan-trackingnumber',
  208: 'icongongdan-carrier',
  209: 'icongongdan-consignee',
  210: 'icona-gongdan-cell-phonenumber',
  211: 'icongongdan-location',
  215: 'iconnonbase-shoppingbag',
  221: 'iconnonbase-shoppingbag', // 商品
  222: 'icongongdan-pay',
  223: 'icona-gongdan-uploadpictures',
  224: 'icongongdan-warehouse',
  230: 'icongongdan-carrier', // 物流信息
  300: 'icona-gongdan-deliveryaddresskit',
  501: 'iconbase-group',
  503: 'icongongdan-jushuitan',
  504: 'iconwangdiantong',
}

export const OriginStatusMap = {
  TRADE_NO_CREATE_PAY: '未下单',
  WAIT_BUYER_PAY: '下单未付款',
  WAIT_SELLER_SEND_GOODS: '待发货',
  SELLER_CONSIGNED_PART: '部分发货',
  PAID_FORBID_CONSIGN: '已付款但禁止发货',
  WAIT_BUYER_CONFIRM_GOODS: '待签收',
  TRADE_FINISHED: '交易成功',
  TRADE_BUYER_SIGNED: '货到付款已签收',
  TRADE_CLOSED: '退款成功',
  TRADE_CLOSED_BY_TAOBAO: '付款以前，交易关闭',
  WAIT_PRE_AUTH_CONFIRM: '0元购合约中',
  REFUND_NO_REFUND: '待发货',
  Weizhi: '未知',
  XinDingDan: '新订单',
  DengDaiFuKuan: '等待付款',
  DengDaiFuKuanQueRen: '等待付款确认',
  YanChiFuKuanQueRen: '延迟付款确认',
  ZanTing: '暂停',
  DianZhangZuiZhongShenHe: '店长最终审核',
  DengDaiDaYin: '等待打印',
  DengDaiChuKu: '等待出库',
  DengDaiDaBao: '等待打包',
  ZiTiTuZhong: '自提途中',
  ShangMenTiHuo: '上门提货',
  ZiTiTuiHuo: '自提退货',
  QueRenZiTi: '确认自提',
  DengDaiHuiZhi: '等待回执',
  DengDaiQueRenShouHuo: '等待确认收货',
  PeiSongTuiHuo: '配送退货',
  HuoDaoFuKuanQueRen: '货到付款确认',
  DengDaiFenQiFuKuan: '等待分期付款',
  ShouKuanQueRen: '收款确认',
  DengDaiKeHuHuiFu: '等待客户回复',
  ChangShangQueRenWanCheng: '厂商确认完成',
  DengDaiZaiShenHe: '等待再审核',
  DuiZhangZhong: '对账中',
  DengDaiSanFangChuKu: '等待三方出库',
  DengDaiSanFangShouHuo: '等待三方发货',
  DengDaiSanFangFaHuoWanCheng: '等待三方发货完成',
  WanCheng: '完成',
  SuoDing: '锁定',
  DengDaiTuiKuan: '等待退款',
  TuiKuanZhong: '退款中',
  WAIT_CONFM: '等待确认收货',
}
